import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../src/config/authAxios"
import CryptoJS from 'crypto-js';



const initialState = { status: null, message: "", loading: false, data: [], error: "" }


export const StartChallenges = createAsyncThunk(
    'get-all-challenge',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/users/api/create-update`, data)
            const encryptedData = res?.data?.data
            const secretKey = process.env.REACT_APP_MY_SECRET_KEY
            const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, secretKey);

            const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);
            const jsonData = JSON.parse(decryptedData);
            let finaldata = {
                ...res?.data, data: jsonData
            }
            return finaldata
        } catch (error) {
            console.log("err", error)
            return rejectWithValue(error.response.data)
        }
    }
)


export const StartChallengesSlice = createSlice({
    name: 'get-all-challenge',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(StartChallenges.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(StartChallenges.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.loading = false
                state.message = action.payload.message
                state.status = action.payload.status
            })
            builder.addCase(StartChallenges.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload.error
                state.message = action.payload.message
                state.status = action.payload.status
            })
        },

})



export const startChallengrReducer = StartChallengesSlice.reducer
